"use strict";
var _a;
exports.__esModule = true;
exports.toDocumentType = void 0;
var types_1 = require("../../types");
var PrismicDocumentType;
(function (PrismicDocumentType) {
    PrismicDocumentType["ARTICLE"] = "article_v2";
    PrismicDocumentType["BRANCH_ACTIVITIES"] = "branch_activities";
    PrismicDocumentType["MEDIA_PRESS"] = "media_presse_v2";
    PrismicDocumentType["COLD_ARTICLE"] = "cold_article";
    PrismicDocumentType["CONTACT"] = "contact";
    PrismicDocumentType["CONTACT_PAGE"] = "contact_page";
    PrismicDocumentType["FINANCIAL_DEBT"] = "financial_debt";
    PrismicDocumentType["FINANCIAL_KEY_FIGURES"] = "financial_key_figures";
    PrismicDocumentType["FINANCIAL_PRESS_RELEASE"] = "financial_press_release";
    PrismicDocumentType["FINANCIAL_PUBLICATION"] = "financial_publication";
    PrismicDocumentType["FINANCIAL_RATING"] = "financial_rating";
    PrismicDocumentType["FOOTER"] = "footer";
    PrismicDocumentType["HEADER"] = "header";
    PrismicDocumentType["HOME"] = "home_page";
    PrismicDocumentType["HUB_ACTUS"] = "hub_actus";
    PrismicDocumentType["HUB_NEWSROOM"] = "hub_newsroom";
    PrismicDocumentType["HOT_ARTICLE"] = "hot_article";
    PrismicDocumentType["LA_POSTE_EN_4"] = "la_poste_en_4";
    PrismicDocumentType["NEWSROOM"] = "newsroom";
    PrismicDocumentType["GOUVERNANCE"] = "organigramme";
    PrismicDocumentType["PUBLIC_SERVICE_MISSIONS"] = "public_service_missions";
    PrismicDocumentType["POSTMEN"] = "postmen";
    PrismicDocumentType["PRESS_RELEASE"] = "press-release";
    PrismicDocumentType["SEARCH_PAGE"] = "search_page";
})(PrismicDocumentType || (PrismicDocumentType = {}));
var PRISMIC_TO_LGLP = (_a = {},
    _a[PrismicDocumentType.ARTICLE] = types_1.DocumentType.ARTICLE,
    _a[PrismicDocumentType.BRANCH_ACTIVITIES] = types_1.DocumentType.BRANCH_ACTIVITIES,
    _a[PrismicDocumentType.MEDIA_PRESS] = types_1.DocumentType.MEDIA_PRESS,
    _a[PrismicDocumentType.COLD_ARTICLE] = types_1.DocumentType.COLD_ARTICLE,
    _a[PrismicDocumentType.CONTACT] = types_1.DocumentType.CONTACT,
    _a[PrismicDocumentType.CONTACT_PAGE] = types_1.DocumentType.CONTACT_PAGE,
    _a[PrismicDocumentType.FINANCIAL_DEBT] = types_1.DocumentType.FINANCIAL_DEBT,
    _a[PrismicDocumentType.FINANCIAL_KEY_FIGURES] = types_1.DocumentType.FINANCIAL_KEY_FIGURES,
    _a[PrismicDocumentType.FINANCIAL_PRESS_RELEASE] = types_1.DocumentType.FINANCIAL_PRESS_RELEASE,
    _a[PrismicDocumentType.FINANCIAL_PUBLICATION] = types_1.DocumentType.FINANCIAL_PUBLICATION,
    _a[PrismicDocumentType.FINANCIAL_RATING] = types_1.DocumentType.FINANCIAL_RATING,
    _a[PrismicDocumentType.FOOTER] = types_1.DocumentType.FOOTER,
    _a[PrismicDocumentType.HEADER] = types_1.DocumentType.HEADER,
    _a[PrismicDocumentType.HOME] = types_1.DocumentType.HOME,
    _a[PrismicDocumentType.HOT_ARTICLE] = types_1.DocumentType.HOT_ARTICLE,
    _a[PrismicDocumentType.HUB_ACTUS] = types_1.DocumentType.HUB_ACTUS,
    _a[PrismicDocumentType.HUB_NEWSROOM] = types_1.DocumentType.HUB_NEWSROOM,
    _a[PrismicDocumentType.NEWSROOM] = types_1.DocumentType.NEWSROOM,
    _a[PrismicDocumentType.LA_POSTE_EN_4] = types_1.DocumentType.LA_POSTE_EN_4,
    _a[PrismicDocumentType.GOUVERNANCE] = types_1.DocumentType.GOUVERNANCE,
    _a[PrismicDocumentType.PUBLIC_SERVICE_MISSIONS] = types_1.DocumentType.PUBLIC_SERVICE_MISSIONS,
    _a[PrismicDocumentType.POSTMEN] = types_1.DocumentType.POSTMEN,
    _a[PrismicDocumentType.PRESS_RELEASE] = types_1.DocumentType.PRESS_RELEASE,
    _a[PrismicDocumentType.SEARCH_PAGE] = types_1.DocumentType.SEARCH_PAGE,
    _a);
var toDocumentType = function (prismicDocumentType, logger) {
    return logger.toConstValue(prismicDocumentType, PRISMIC_TO_LGLP);
};
exports.toDocumentType = toDocumentType;
//# sourceMappingURL=document-type.js.map